<template>
    <div id="profile" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area" v-show="showScheduleList == 0">
            <div class="page-name">
                <div class="page-title">Maintenance Schedule List</div>
                <button id="addAssetMaintenanceScheduleBtn" v-on:click.prevent="addAssetMaintenanceSchedule" class="btn btn-primary pull-right" v-if="canAddSchedule" > <i class="fp-add"> </i> Add</button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content maintenance-schedule">
                    <section class="internal-container border-top-table-fl">
                        <div class="form-row">
                            <div class="col form-group">
                                <v-select class="close-remove" v-model="asset_location_id" name="asset_location_id" placeholder="Select Location."
                                            label="text"
                                            :options="locationArr" @input="locationchange">
                                </v-select>
                            </div>
                            <div class="col form-group">
                                <v-select v-model="asset_maintenance_type" name="asset_maintenance_type" placeholder="Select Maintenance Type."
                                            label="text"
                                            :options="maintenanceTypeArr" @input="maintenancetypechange">
                                </v-select>
                            </div>
                            <div class="col form-group">
                                <v-select v-model="asset_customer_id" name="asset_customer_id"
                                    label="text" :filterable="false" :options="customerArr"
                                    @search="onSearchCustomer" @input="customerchange"
                                    placeholder="Select Customer" class="custom-ci-auto-search">
                                    <template slot="no-options">
                                        Search Customer...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>

                            <div class="col-1 form-group">
                                <button type="submit" v-on:click.prevent="resetFilter()" class="btn btn-tertiary pull-right">
                                    <i class="fp-refresh"></i> Reset
                                </button>
                            </div>

                        </div>
                        <div class="mb-4 btn-groups text-right">
                            <template v-for="(key, index) in keysArr">
                                <template v-if='key.is_view == 1'>
                                    <button
                                        :key='key.value+"_"+key.is_view'
                                        @click="changeVisible(key.value)"
                                        :id="'key_'+key.value" class="mt-2 mr-3 btn"
                                        :title='key.text + " is visible"'
                                        :style="'color:#FFFFFF;background:'+ key.color_code + ';border:'+ key.color_code + '; opacity:1;'"
                                        >{{key.text}}</button>
                                </template>
                                <template v-else>
                                    <button
                                        :key='key.value+"_"+key.is_view'
                                        @click="changeVisible(key.value)"
                                        :id="'key_'+key.value" class="mt-2 mr-3 btn"
                                        :title='key.text + " is not visible"'
                                        :style="'color:#FFFFFF;background:'+ key.color_code+';border:'+ key.color_code+'; opacity:0.5;'"
                                        >{{key.text}}</button>
                                </template>
                            </template>
                        </div>
                        <div class="SMcalendarContainer">
                            <div class="nevCalendar" style="float:left;">
                                <button id="" class="btn btn-primary" @click="previousMonth" ><i style="font-size:24px;padding:0" class="fp-left-arrow" aria-hidden="true"></i></button>
                                <button id="" class="btn btn-primary" @click="nextMonth"><i style="font-size:24px;padding:0" class="fp-right-arrow" aria-hidden="true"></i></button>
                            </div>
                            <full-calendar id="SMcalendar" :events="display_events" :config="config" ref="SMcalendar"/>
                        </div>
                    </section>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
        <div id="page-content-wrapper" class="admin-content-area" v-show="showScheduleList == 1">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ContractHeader" v-if="schedule_maintenance_id > 0">Update Maintenance Schedule</span>
                    <span class="page-title" id="ContractHeader" v-else>Add Maintenance Schedule</span>
                    <div class="btn-groups text-right">
                        <router-link v-if="schedule_maintenance_id > 0 && customer_id > 0" class="btn btn-primary" v-bind:to="{name: 'WorkOrderCreate',params:{customerId: customer_id,customerName: customer_name, customerCode: customer_code, scheduleMaintenanceId : schedule_maintenance_id, vehicleUnitNo: vehicle_unit_no, scheduleDate: schedule_date, vehicleTypeCode: vehicle_type_code, vehicleName: vehicle_name, vehicleId: vehicle_id,locationId: location_id,scheduleDate:vehicleScheduledDate,schedule_notes:notes}}">Create Work Order</router-link>
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="backToCalendar">
                            <i class="fp-back"> </i>    Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <div id="tabs" class="containerTab">
                            <div id="tabLinks" class="tabs">
                                <a id="scheduleTab" v-on:click="scheduleTab(this)">Schedule</a>
                                <!-- Show Activity Tab if Maintenance Schedule Update and Asset available -->
                                <a id="activityTab" v-on:click="activityTab(this)" v-if="isEditing == true && vehicle_id != null">Activity</a>
                            </div>
                            <div class="content">
                                <div v-if="scheduletabis == true" class="tabcontent">
                                    <div class="internal-container">
                                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="AssetScheduleForm">
                                            <div class='form-row row-cols-md-4 row-cols-1'>
                                                <div class="col form-group">
                                                    <label class="control-label require" for="vehicle_id">Unit:</label>
                                                    <router-link class="pull-right link-text color-blue" v-bind:to="{name: 'AssetCreate', params:{newAsset: searchedAsset, redirectFrom: 'MaintenanceSchedule'}}">
                                                        <i class="fp-add font-weight-bold" style="font-size:8px"></i> Add Unit
                                                    </router-link>
                                                    <v-select v-model="vehicle_id" id="vehicle_select" name="vehicle_id"
                                                        label="text" :filterable="false" :options="vehicleArr"
                                                        @search="onSearchAsset"
                                                        placeholder="Select Unit" @input="onAssetSelect" class="close-remove custom-ci-auto-search" :disabled="disableAssetField">
                                                        <template slot="no-options">
                                                            Search Unit...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{ asset_error_msg }}</div>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label" for="estimate_id">Customer Estimate:</label>
                                                    <router-link class="pull-right link-text color-blue" v-if="estimate_id != null && estimate_id.value" v-bind:to="{name: 'CustomerEstimateView', params:{id: estimate_id.value, redirectFrom: 'MaintenanceSchedule'}}">
                                                        <i class="fp-view font-weight-bold" style="font-size:8px"></i> {{estimate_id.estimate_no}}
                                                    </router-link>
                                                    <v-select v-model="estimate_id" name="estimate_id" placeholder="Select Customer Estimate."
                                                        label="text"
                                                        :options="estimateArr" @input="onEstimateSelect()">
                                                    </v-select>
                                                    <div class="field-error">{{ estimate_error_msg }}</div>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label require" for="schedule_status">Status:</label>
                                                    <v-select v-model="schedule_status" name="schedule_status" placeholder="Select Schedule Status."
                                                        label="text" class="close-remove"
                                                        :options="scheduleStatusArr">
                                                    </v-select>
                                                    <div class="field-error">{{ schedule_status_error_msg }}</div>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label require" for="schedule_date">Schedule From Date:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="schedule_date" name="schedule_date" v-model="schedule_date" :config="optionsDate"></date-picker>
                                                        <label for="schedule_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <div class="field-error">{{ schedule_date_error_msg }}</div>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label require" for="schedule_time">From Time:</label>
                                                    <v-select class="close-remove" v-model="schedule_time"  id="schedule_time" label="text" :options="timeArr">
                                                    </v-select>
                                                    <div class="field-error">{{ schedule_time_error_msg }}</div>
                                                </div>
                                                <!-- <div class="col form-group">
                                                    <label class="control-label require" for="schedule_date">Schedule To Date:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="schedule_to_date" name="schedule_to_date" v-model="schedule_to_date" :config="optionsDate" ></date-picker>
                                                        <label for="schedule_to_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <div class="field-error">{{ schedule_to_date_error_msg }}</div>
                                                </div> -->
                                                <!-- <div class="col form-group">
                                                    <label class="control-label require" for="schedule_to_time">To Time:</label>
                                                    <v-select class="close-remove" v-model="schedule_to_time"  id="schedule_to_time" label="text" :options="timeArr">
                                                    </v-select>
                                                    <div class="field-error">{{ schedule_to_time_error_msg }}</div>
                                                </div> -->
                                                <div class="col form-group">
                                                    <label class="control-label require" for="location">Location:</label>
                                                    <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                        label="text" class="close-remove"
                                                        :options="locationArr">
                                                    </v-select>
                                                    <div class="field-error">{{ location_error_msg }}</div>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label require" for="maintenance_type">Maintenance Type:</label>
                                                    <v-select v-model="maintenance_type" name="maintenance_type" placeholder="Select Maintenance Type."
                                                        label="text" class="close-remove" @input="onMaintenanceTypeChange"
                                                        :options="maintenanceTypeArr">
                                                    </v-select>
                                                    <div class="field-error">{{ maintenance_type_error_msg }}</div>
                                                </div>
                                                <div class="col form-group" v-if="recallName">
                                                    <label class="control-label">Recall:</label>
                                                    <v-select v-model="recalls" :options="recallArr" label="text" name="recall"
                                                        placeholder="Recall" id="recall" class="custom-vselect">
                                                    </v-select>
                                                    <div class="field-error">{{ recall_name_error_msg }}</div>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label" for="period">Notes:</label>
                                                    <textarea type="text" class="form-control" v-model="notes" id="attention" placeholder="Enter Notes" name="Notes" />
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="alert alert-warning hide col-sm-6" id="alertError">
                                                    <strong id="errorMsg" class="error"></strong>
                                                </div>
                                            </div>
                                            <div class="btn-groups">
                                                <button type="submit" id="createAssetScheduleBtn" class="btn btn-primary" v-on:click.prevent="createAssetSchedule" >
                                                <i class="fp-save"> </i>  Save
                                                </button>
                                                <button type="submit" id="cancelAssetScheduleBtn" class="btn btn-tertiary" v-on:click.prevent="backToCalendar" >
                                                <i class="fp-close"> </i>  Cancel
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                    <hr class="light-hr"/>
                                    <div v-if="showDetailInfo == 'show'" class="Schedule2">
                                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="AssetScheduleDetails">
                                            <div class="form-row row-cols-md-3 row-cols-1">
                                                <div class="col form-group">
                                                    <div class="form-row">
                                                        <label class="col" for="last_service_date">Last Service Date:</label>
                                                        <span class="col">{{last_service_date}}</span>
                                                    </div>
                                                </div>
                                                <div class="col form-group">
                                                    <div class="form-row">
                                                        <label class="col" for="default_schedule_date">Default Schedule Date:</label>
                                                        <span class="col">{{default_schedule_date}}</span>
                                                    </div>
                                                </div>
                                                <div class="col form-group">
                                                     <div class="form-row">
                                                        <label class="col" for="customer">Customer:</label>
                                                        <span class="col">{{customer_name}}</span>
                                                    </div>
                                                </div>
                                                <div class="col form-group">
                                                     <div class="form-row">
                                                        <label class="col" for="default_schedule_date">Pickup Date :</label>
                                                        <span class="col">{{rPickUpDate}}</span>
                                                    </div>
                                                </div>
                                                <div class="col form-group">
                                                     <div class="form-row">
                                                        <label class="col" for="default_schedule_date">Dropoff Date :</label>
                                                        <span class="col">{{rDropOffDate}}</span>
                                                    </div>
                                                </div>
                                                <div class="col form-group">
                                                    <div class="form-row">
                                                        <label class="col" for="default_schedule_date"> Reservation No:</label>
                                                        <span class="col">{{reservation_no}}</span>
                                                    </div>
                                                </div>
                                                <div class="col form-group">
                                                    <div class="form-row">
                                                        <label class="col" for="default_schedule_date"> Maintenance Type :</label>
                                                        <span class="col">{{ maintenance_type_name }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="">
                                                <label class="control-label" v-if="contactsArr && contactsArr.length > 0">Customer Details</label>
                                                <div class="form-row row-cols-md-3 row-cols-1" v-for="(contact, index) in contactsArr" v-bind:key="index">
                                                    <div class="col form-group">
                                                        <div class="form-row">
                                                            <label class="col" for="default_schedule_date"> Contact Name:</label>
                                                            <label class="col">{{ contact.contact_name+ ' (' +contact.contact_isdefault+ ')' }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="col form-group">
                                                        <div class="form-row">
                                                            <label class="col" for="default_schedule_date"> Email:</label>
                                                            <label class="col">{{ contact.contact_email }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="col form-group">
                                                        <div class="form-row">
                                                            <label class="col" for="default_schedule_date"> Phone:</label>
                                                            <label class="col">{{ contact.contact_workphone }}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="btn-groups">
                                                <button type="submit" id="createAssetScheduleBtn" class="btn btn-primary" v-on:click.prevent="createworkorder" >
                                                <i class="fp-add"> </i>  Add Work Order
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div v-if="activitytabis == true" class="tabcontent">
                                    <app-crm-create id="activityScheduleCrm" :activityScheduleVal="actiSchedVal" :assetIdVal="vehicle_id" :customerIdVal="customer_id" :customerNameVal="customer_name" :locationIdVal="location_id" v-if="activitytabis == true"></app-crm-create>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                    </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
             <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";

import moment from 'moment'
import FullCalendar from "vue-full-calendar";
import {contractMixins} from '../mixins/contractMixins';
import {commonMixins} from '../mixins/commonMixins';
// Vue.component("full-calendar", FullCalendar);
import "fullcalendar/dist/fullcalendar.min.css";
import CrmCreate from '@/components/CrmCreate'

var contex
Vue.use(FullCalendar);
Vue.component("app-crm-create", CrmCreate);

export default {
    name: "MaintenanceSchedule",
    
    mixins:[commonMixins,contractMixins],
    data() {
        return {
            maintenance_type_name: '',

            renderedView: '',

            searchedAsset: '',

            vehicle_unit_no: '',
            vehicle_type_code: '',
            vehicle_name: '',
            customer_code: '',
            isEditing: false,
            // totalMonthEvents: 0,
            showDetailInfo: 'show',
            contactsArr: [],
            defaultContactsArr: [],
            rPickUpDate: '-',
            rDropOffDate: '-',
            reservation_no: '-',
            custEmailId: '-',
            canAddSchedule: true,
            userRole: "",
            display_events: [],
            keysArr: [],
            asset_location_id:null,
            asset_maintenance_type:'',
            asset_customer_id:null,
            customerArr:[],
            startDateFrom: 0,
            endDateTo: 0,
            loading:false,
            schedule_maintenance_id: 0,
            vehicle_id: null,
            notes: '',
            last_service_date: '-',
            vehicleArr: [],
            asset_error_msg: '',
            default_schedule_date: '-',
            customer_id: null,
            customer_name: '-',
            location_id:null,
            location_error_msg:'',
            locationArr:[],
            schedule_date:'',
            schedule_to_date:'',
            schedule_time:null,
            schedule_to_time:null,
            scheduleStatusArr: [
                {value: "pending" , text:"Pending"},
                {value: "confirmed" , text:"Confirmed"},
                {value: "closed" , text:"Closed"},
                {value: "cancel" , text:"Cancel"}
            ],
            schedule_status: {
                value: "pending" ,
                text: "Pending"
            },
            schedule_date_error_msg:'',
            schedule_to_date_error_msg:'',
            schedule_time_error_msg:'',
            schedule_to_time_error_msg:'',
            schedule_status_error_msg: '',
            maintenance_type: null,
            maintenanceTypeArr: [

            ],
            maintenance_type_error_msg: '',
            recall_name_error_msg: '',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
                minDate:moment().millisecond(0).second(0).minute(0).hour(0),//new Date(),
                // showClose: true,
            },
            cantAccessPage: '',
            showScheduleList: 0,
            permissions: [],
            selectedEvent: {},
            events: [
                    // {
                    //     title: 'test',
                    //     // allDay: true,
                    //     start: '2019-09-01 10:12:08',
                    //     end: '2019-09-01 11:12:08',
                    // }
                ],
            config: {

                /*'weekends': false,*/
                contentHeight:900,//to define height of cell
                defaultDate: moment(new Date()).format("YYYY-MM-DD"),
                defaultView: 'listDay',
                displayEventTime: false,
                editable: false,
                eventLimit: true,
                noEventsMessage: "Calender Entries Not Available",

                viewRender: (view, element) => {
                    var self  = this;
                    self.renderedView = view;
                },

                eventRender: function(event, element) {
                    //not working in day, week and list for technician_hours
                    /*if (event.description == "technician_hours") {
                        element.find('.fc-title').html(event.titleObj.entry);
                        element.find('.fc-title').append("<br/>" + event.titleObj.intermediate);
                        element.find('.fc-title').append("<br/>" + event.titleObj.senior);
                    }*/
                    if(event.description == 'baycount'){
                        element.addClass('bay-count');
                    }
                    if(event.dateFrom!=null && event.dateTo !=null){
                        element.find('.fc-title').append("<br/>" + event.dateFrom);
                        element.find('.fc-title').append("<br/>" + event.dateTo);

                        element.find('.fc-list-item-title').append("<br/>" + event.dateFrom);
                        element.find('.fc-list-item-title').append("<br/>" + event.dateTo);
                    }

                },

                eventAfterAllRender: (view) => {
                    var quantity = $('.fc-event').length;
                    // this.totalMonthEvents = quantity;
                },

                dayClick: function(date, jsEvent, view) {

                },

                eventClick: (event) => {
                    console.log(event);
                    this.selectedEvent = event;
                    // Remove Opening Form when Clicking on baycount, tech hours Row
                    if (this.selectedEvent.description == "holiday" ) {
                        alert("It's holiday!");
                    }else{
                        if(this.selectedEvent.description!="baycount" && this.selectedEvent.description!="technician_hours"){
                            this.showEditMaintenance(event);
                        }
                    }

                },
                header: {
                    left: '',
                    // left:  'prev,next',
                    center: 'title',
                    right: 'listDay,listWeek,month,listMonth',
                },
                buttonText: {
                    'month': 'Month',
                    'listMonth': 'List',
                    'listWeek': 'Week',
                    'listDay': 'Day'
                }
            },
            scheduletabis:false,
            activitytabis:false,
            actiSchedVal:"maintenance schedule",
            isAssetNotFound:false,
            disableAssetField:false,
            recalls:'',
            recallArr:[],
            recallName:false,
            vehicleScheduledDate:'',
            estimate_error_msg:'',
            estimate_id:'',
            estimateArr:[]
        }
    },
    beforeMount: function() {
            contex = this;
    },
  watch:{

        renderedView: function(){
            var self = this;
            self.getScheduledAssetList();
        },

        vehicle_id: function(v_id) {
            var self = this;

            if(self.isEditing == false){
                self.schedule_date = '';
                self.schedule_maintenance_id = 0;
                self.default_schedule_date = '-';
                self.last_service_date = '-';
                self.notes = '';

                self.customer_id = null;
                self.customer_name = '-';

                self.vehicleArr = [];
                self.contactsArr = [];
                self.defaultContactsArr = [];
                self.rPickUpDate = '-';
                self.rDropOffDate = '-';
                self.reservation_no = '-';
                self.custEmailId = '-';
                self.maintenance_type_name = '-';

                self.maintenance_type = null;
                self.recalls = '';

                self.schedule_status = { value: "pending" , text: "Pending" };

                self.asset_error_msg = "";
                self.location_error_msg = "";
                self.schedule_date_error_msg = "";
                self.schedule_status_error_msg = "";
                self.maintenance_type_error_msg = "";
                self.recall_name_error_msg = "";
                self.estimate_id = null;

                $(".alert-warning").addClass("hide");
                $(".alert-warning").removeClass("show");
            }
        },

        schedule_date: function(s_date) {
            var self = this;

            if (self.vehicle_id != null && s_date != "" && s_date != "-" && s_date != null) {

                var v_id = self.vehicle_id.value;
                var sm_id = self.schedule_maintenance_id;
                if (self.$route.query.data == undefined){
                    self.getAssetDetails(v_id, sm_id, s_date);
                }

            }


        },
        /*maintenance_type: function(newVal){
            var self = this;
            if (newVal != null) {
                if(newVal.text == 'Recall'){

                    self.recallName = true;
                    self.getRecalls();
                    return;
                }else{
                    self.recallName = false;
                }
            }

        },*/

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_schedule_maintenance') {
                        self.cantAccessPage = true;
                    }

                    if(permissions[i].name == 'add_schedule_maintenance'){
                        self.canAddSchedule = true;
                    }
                }
            }

        }

  },
  created: function() {

  },
  beforeDestroy(){
    this.$root.$off('activity');
  },
  mounted: function() {
        var self = this;
        this.$root.$on('activity', () => {
            self.showScheduleList = 0;
        });
        self.getPermissions();
        self.loadFieldData(['location','vom','source','status','shop','standarddefects','maintenance_type']);
        var userObj = localStorage.getItem("user_obj");
        console.log(userObj);
        //if user logged in than remove login button and registration button
        if ( userObj != null ) {
            var userJson = JSON.parse(userObj);

            if (userJson.roles.length > 0) {
                this.userRole = userJson.roles[0].name;
                this.userRole = this.userRole.toLowerCase();//convert userRole to lowercase
            }

            if(userJson && userJson.location_id != null && userJson.location_id  != ''){
                self.asset_location_id = {value: userJson.location_id, text: self.titleCase(userJson.locationName) };
            }

        }

        if(self.$route.params.redirectTo == 'Add Schedule Maintenance'){

            var vehicleData = self.titleCase(self.$route.params.assetUnitNo);
            if(self.$route.params.assetType != null && self.$route.params.assetType != ''){
                if(self.$route.params.assetType.vtCode != null && self.$route.params.assetType.vtCode != ''){
                    vehicleData += " | " + self.titleCase(self.$route.params.assetType.vtCode);
                }
            }
            if(self.$route.params.assetName != null && self.$route.params.assetName != ''){
                vehicleData += " | " + self.titleCase(self.$route.params.assetName);
            }
            if(self.$route.params.assetLocation != null && self.$route.params.assetLocation != ''){
                if(self.$route.params.assetLocation.location_name != null && self.$route.params.assetLocation.location_name != ''){
                    vehicleData += " | " + self.titleCase(self.$route.params.assetLocation.location_name);
                }
            }
            self.vehicle_id = {value: self.$route.params.assetId, text: vehicleData};

            self.scheduleTab()

        }

        if (self.$route.query.data != undefined){
            // self.showScheduleList = 1;
            var dta = atob(self.$route.query.data);
            // console.log('hrer');
            // console.log(JSON.parse(dta));
            self.addAssetMaintenanceSchedule();
            self.loadScheduleFromPM(JSON.parse(dta));
        }else{
            self.getScheduledAssetList();
        }


  },
  metaInfo() {
      var titleStr = "Maintenance Schedule List | " +process.env.COPYRIGHT_NAME;
      if (this.showScheduleList == 1) {
          if (this.schedule_maintenance_id > 0) {
              titleStr = "Update Maintenance Schedule | " +process.env.COPYRIGHT_NAME
          }else{
              titleStr = "Create Maintenance Schedule | " +process.env.COPYRIGHT_NAME
          }
      }
      return{
          title: titleStr
      }
  },
  methods: {
    resetFilter() {
        var self = this;
        self.asset_customer_id = "";
        self.asset_maintenance_type = "";
        self.getScheduledAssetList();
    },
    scheduleTab(){
        var self = this;
        self.showScheduleList = 1;
        $('#tabLinks a').removeClass("active");
        $("#scheduleTab").addClass("active");
        self.scheduletabis = true;
        self.activitytabis = false;
    },
    activityTab(){
        var self = this;
        $('#tabLinks a').removeClass("active");
        $("#activityTab").addClass("active");
        self.scheduletabis = false;
        self.activitytabis = true;
    },
    clearFields(){

        var self = this;

        self.vehicle_id = null;
        self.estimate_id = null;
        self.schedule_maintenance_id = 0;
        self.default_schedule_date = '-';
        self.last_service_date = '-';
        self.notes = '';
        self.schedule_date = '';
        self.schedule_to_date='';
        self.schedule_time=null;
        self.schedule_to_time=null;

        self.customer_id = null;
        self.customer_name = '-';

        self.vehicleArr = [];
        self.contactsArr = [];
        self.defaultContactsArr = [];
        self.rPickUpDate = '-';
        self.rDropOffDate = '-';
        self.reservation_no = '-';
        self.custEmailId = '-';
        self.maintenance_type_name = '-';

        self.asset_error_msg = "";
        self.location_error_msg = "";
        self.schedule_date_error_msg = "";
        self.schedule_status_error_msg = "";
        self.maintenance_type_error_msg = "";
        self.recall_name_error_msg = "";
        self.recallName = false;
        self.schedule_to_date_error_msg='';
        self.schedule_time_error_msg='';
        self.schedule_to_time_error_msg='';
        self.estimate_error_msg='';

    },

    addAssetMaintenanceSchedule(){
        var self = this;
        // self.showScheduleList = 1;

        // if ($('#vehicle_select').hasClass('disable-field')) {
        //     $('#vehicle_select').removeClass('disable-field');
        // }
        self.isEditing = false;
        self.disableAssetField = false;

        self.clearFields();
        self.scheduleTab();

        var userObj = localStorage.getItem("user_obj");

        //if user logged in than remove login button and registration button
        if ( userObj != null ) {
            var userJson = JSON.parse(userObj);

            if(userJson && userJson.location_id != null && userJson.location_id  != ''){
                self.location_id = {value: userJson.location_id, text: self.titleCase(userJson.locationName) };
            }
        }
    },

    getRecalls: function(){
        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/recalls/get",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                    self.recallArr = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, true, 'maintenance-get-recalls');
            }
        });
    },

    changeVisible(id) {
        var self = this;
        var activeKey = [];
        var tempArr = self.keysArr;
        self.keysArr = [];
        $.each(tempArr, function (i) {
            if (id == tempArr[i].value) {
                tempArr[i].is_view = (tempArr[i].is_view == 1) ? 0 : 1;
            }
            if (tempArr[i].is_view == 1) {
                activeKey.push(tempArr[i].value);
            }
            self.keysArr.push(tempArr[i]);
        });
        self.$nextTick(function () {
            self.display_events = [];
            $.each(self.events, function (i) {
                if ($.inArray(self.events[i].status_id, activeKey) != "-1") {
                    /*console.log(self.events[i].status_id);*/
                    self.display_events.push(self.events[i]);
                }
            });
            /*console.log(self.display_events);*/
            self.$refs.SMcalendar.$emit('refetch-events');
        });
    },

    getAssetDetails(v_id, s_id, s_date){
        var self = this;

        self.default_schedule_date = '-';
        self.last_service_date = '-';
        self.notes = '';

        self.customer_id = null;
        self.customer_name = '-';

        self.contactsArr = [];
        self.defaultContactsArr = [];
        self.rPickUpDate = '-';
        self.rDropOffDate = '-';
        self.reservation_no = '-';
        self.custEmailId = '-';

        self.asset_error_msg = "";
        self.location_error_msg = "";
        self.schedule_date_error_msg = "";
        self.schedule_status_error_msg = "";
        self.maintenance_type_error_msg = "";
        self.recall_name_error_msg = "";

        self.loading = true;


        $.ajax({
            url: process.env.ROOT_API + "/schedule_maintenance/get_asset_maintenance_schedule",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                vehicle_id: v_id,
                schedule_maintenance_id: s_id,
                schedule_date: s_date
            },
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    // self.showDetailInfo = 'show';
                    self.contactsArr = [];

                    if(data.content.reservationdetails != undefined){

                        var resDetails = data.content.reservationdetails;
                        self.reservation_no = resDetails.reference_no;
                        self.rPickUpDate = resDetails.pickup_datetime;
                        self.rDropOffDate = resDetails.dropoff_datetime;

                    }

                    if(data.content.reservationdetails != undefined && data.content.reservationdetails.customerId != undefined){
                        var resDetails = data.content.reservationdetails;
                        self.customer_id = resDetails.customerId;
                        self.customer_name = resDetails.customerName;
                        self.customer_code = resDetails.customerCode;
                    }

                    if(data.content.contacts != undefined){

                        self.contactsArr = data.content.contacts;

                    }

                    if(data.content.defaultcontact != undefined){

                        self.defaultContactsArr = data.content.contacts;

                    }

                    var assetdetail = data.content.assetdetail;
                    if (assetdetail != undefined && assetdetail != null) {
                        if(assetdetail.date_in_service != undefined && assetdetail.date_in_service != null){
                            self.last_service_date = assetdetail.date_in_service;
                        }
                        if(assetdetail.default_schedule_date != undefined && assetdetail.default_schedule_date != null){
                            self.default_schedule_date = assetdetail.default_schedule_date;
                        }

                        // No need to set asset location now...
                        // self.location_id = {value: assetdetail.locationId, text: self.titleCase(assetdetail.locationName) + " (" + self.titleCase(assetdetail.locationCode) +")"};


                        if(assetdetail.customerId != undefined && assetdetail.customerId != null){

                            self.customer_id = assetdetail.customerId;
                            self.customer_name = self.titleCase(assetdetail.customerName);
                            self.customer_code = assetdetail.customerCode;

                        }

                        if(assetdetail.maintenance_typeName != undefined && assetdetail.maintenance_typeName != null){

                            self.maintenance_type_name = assetdetail.maintenance_typeName;
                            // self.customer_name = self.titleCase(assetdetail.customerName);
                            // self.customer_code = assetdetail.customerCode;

                        }
                        if(assetdetail.reference_no != undefined && assetdetail.reference_no != null){

                            self.reservation_no = assetdetail.reference_no;
                            self.rPickUpDate = assetdetail.pickup_datetime;
                            self.rDropOffDate = assetdetail.dropoff_datetime;
                        }

                        if(assetdetail.scheduleMaintenanceId != undefined && assetdetail.scheduleMaintenanceId != null){

                            self.schedule_maintenance_id = assetdetail.scheduleMaintenanceId;
                            // self.schedule_date = assetdetail.schedule_date;
                            self.schedule_status = {value: assetdetail.schedule_status, text: self.titleCase(assetdetail.schedule_status) };
                            self.notes = assetdetail.notes;
                            self.maintenance_type = {value: assetdetail.maintenanceTypeId, text: self.titleCase(assetdetail.maintenance_typeName) };

                        }
                        if(assetdetail.estimate_id != undefined && assetdetail.estimate_id != null){
                            var estimateText = self.titleCase(assetdetail.est_number) + " | " + self.ucString(assetdetail.est_status);
                            self.estimate_id = {value: assetdetail.estimate_id, text: estimateText,estimate_no:assetdetail.est_number };
                        }
                        if(assetdetail.name != undefined && assetdetail.name != null){
                            self.recalls = {text:assetdetail.name,value:assetdetail.name};
                        }else{
                            self.recalls = '';
                        }
                        if (self.maintenance_type != null) {
                            if (self.maintenance_type.text.toLowerCase() == "recall") {
                                self.recallName = true;
                            }else{
                                self.recallName = false;
                            }
                        }else{
                            self.recallName = false;
                        }
                        self.fetchAssetEstimate();
                    }

                    // self.schedule_date= assetdetail.schedule_date;
                    // self.schedule_to_date=assetdetail.schedule_to_date;
                    // self.schedule_time={text:assetdetail.schedule_time,value:assetdetail.schedule_time24};
                    // self.schedule_to_time={text:assetdetail.schedule_to_time,value:assetdetail.schedule_to_time24};

                    if(data.content.warningMsg != undefined){

                        $("#errorMsg").html(data.content.warningMsg);
                        $(".alert-warning").addClass("show");
                        $(".alert-warning").removeClass("hide");

                    }

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR, true, 'asset-maintenance-schedule');
            }
        });


    },

    locationchange(evt){
        var self = this;
        self.asset_location_id = {value: evt.value, text: self.titleCase(evt.text) };

        self.getScheduledAssetList();
    },

    maintenancetypechange(evt){

        var self = this;

        self.asset_maintenance_type = (evt != null)?{value: evt.value, text: self.titleCase(evt.text) }:'';

        self.getScheduledAssetList();

    },

    customerchange(evt){

        var self = this;

        self.asset_customer_id = (evt != null)?{value: evt.value, text: self.titleCase(evt.text)}:null;

        self.getScheduledAssetList();

    },

    previousMonth() {
        var self = this;
        self.$refs.SMcalendar.fireMethod('prev');
        self.startDateFrom = self.$refs.SMcalendar.fireMethod('getView').start.format();
        self.endDateTo = self.$refs.SMcalendar.fireMethod('getView').end.format();
        // self.loadCalendarEvents();
        self.getScheduledAssetList();
    },
    nextMonth() {
        var self = this;
        self.$refs.SMcalendar.fireMethod('next');
        self.startDateFrom = self.$refs.SMcalendar.fireMethod('getView').start.format();
        self.endDateTo = self.$refs.SMcalendar.fireMethod('getView').end.format();
        // self.loadCalendarEvents();
        self.getScheduledAssetList();
    },

    createAssetSchedule(){
        var self = this;
        var error = false;

        self.asset_error_msg = "";
        self.location_error_msg = "";
        self.schedule_date_error_msg = "";
        self.schedule_status_error_msg = "";
        self.maintenance_type_error_msg = "";
        self.recall_name_error_msg = "";
        self.schedule_to_date_error_msg='';
        self.schedule_time_error_msg='';
        self.schedule_to_time_error_msg='';

        if (self.vehicle_id == null || !self.vehicle_id.value) {
            self.asset_error_msg = "Unit Required.";
            error = true;
        }

        if (!self.schedule_date || self.schedule_date == null || self.schedule_date == "") {
            self.schedule_date_error_msg = "Schedule Date Required.";
            error = true;
        }
        /*if (!self.schedule_to_date || self.schedule_to_date == null || !self.schedule_to_date !="" ) {
            self.schedule_to_date_error_msg = "Schedule To Date Required.";
            error = true;
        }else{
            if (self.schedule_date || self.schedule_date != null || self.schedule_date != "") {
                    if(new Date(self.schedule_to_date) < new Date(self.schedule_date)){
                        self.schedule_to_date_error_msg = "Schedule to date not be less than from date.";
                        error = true;
                    }
            }
        }*/
        if (self.schedule_time == null || !self.schedule_time.value) {
            self.schedule_time_error_msg = "Schedule From Time Required.";
            error = true;
        }

        /*if (self.schedule_to_time == null || !self.schedule_to_time.value) {
            self.schedule_to_time_error_msg = "Schedule To Time Required.";
            error = true;
        }else{
             if ((self.schedule_date || self.schedule_date != null || self.schedule_date != "")
             && (self.schedule_to_date || self.schedule_to_date != null || self.schedule_to_date != "")
             && (self.schedule_time!=null || self.schedule_time.value)) {
                var fromDate = moment(self.schedule_date+" "+self.schedule_time.text).format("MM/DD/YYYY hh:mm:ss a");
                var toDate = moment(self.schedule_to_date+" "+self.schedule_to_time.text).format("MM/DD/YYYY hh:mm:ss a");
                // console.log("from:"+fromDate+" To:"+toDate);
                if(Date.parse(toDate) <= Date.parse(fromDate)){
                    self.schedule_to_time_error_msg = "Schedule to time cannot be less than from schedule date time.";
                    error = true;
                }

             }
        }*/
        if (self.location_id == null || !self.location_id.value) {
            self.location_error_msg = "Location Required.";
            error = true;
        }

        if (self.schedule_status == null || !self.schedule_status.value) {
            self.schedule_status_error_msg = "Schedule Status Required.";
            error = true;
        }

        if (self.maintenance_type == null || !self.maintenance_type.value) {
            self.maintenance_type_error_msg = "Maintenance Type Required.";
            error = true;
        }

        if ( self.recallName){

            if (self.recalls == null || !self.recalls.value) {
                self.recall_name_error_msg = "Recall Name Required.";
                error = true;
            }
        }


        if (!error) {

            self.loading = true;

            $("#createAssetScheduleBtn").val("Saving ...");
            $("#createAssetScheduleBtn").prop("disabled", true);
            $("#cancelAssetScheduleBtn").prop("disabled",true);

            var fields = $("#AssetScheduleForm").serializeArray();
            fields.push({name: "vehicle_id", value: self.vehicle_id.value});
            fields.push({name: "default_schedule_date", value: self.default_schedule_date});
            fields.push({name: "notes", value: self.notes});
            // fields.push({name: "schedule_date", value: self.schedule_date});
            fields.push({name: "location_id", value: self.location_id.value});
            fields.push({name: "customer_id", value: self.customer_id});
            fields.push({name: "schedule_time", value: self.schedule_time.value});
            // fields.push({name: "schedule_to_time", value: self.schedule_to_time.value});
            fields.push({name: "schedule_status", value: self.schedule_status.value});
            fields.push({name: "maintenance_type", value: self.maintenance_type.value});
            fields.push({name: "schedule_maintenance_id", value: self.schedule_maintenance_id});
            if (self.estimate_id != null  && self.estimate_id.value != undefined && self.estimate_id.value != null){
                fields.push({name: "estimate_id", value: self.estimate_id.value});
            }else{
                fields.push({name: "estimate_id", value: ''});
            }

            if ( self.recallName){

                fields.push({name: "recall", value: self.recalls.text});
            }

            console.log(fields);//return;
            $.ajax({
                url: process.env.ROOT_API + "/maintenance-schedule/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    $("#createAssetScheduleBtn").val("Save");
                    $("#createAssetScheduleBtn").prop("disabled", false);
                    $("#cancelAssetScheduleBtn").prop("disabled",false);

                    if (data.status == "success") {

                        self.showScheduleList =  0;
                        self.getScheduledAssetList();
                        self.clearFields();     //clear all fields

                        if (self.$route.query.data != undefined){
                            self.$router.push('/maintenance-schedule');
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;

                    $("#createAssetScheduleBtn").val("Save");
                    $("#createAssetScheduleBtn").prop("disabled", false);
                    $("#cancelAssetScheduleBtn").prop("disabled",false);
                    self.generateStatusCodeMessage(jqXHR, false, 'create-maintenance-schedule');
                }
            });
        }else{
          self.errorValidationFocus();
        }
    },
    createworkorder(){
        var self = this;
        var schedule_maintenance_id = self.schedule_maintenance_id;
        self.$router.push({name:'WorkOrderCreate',params: { schedule_id: schedule_maintenance_id ,flag: 'true' }});
    },
    backToCalendar(){
        var self = this;
        self.clearFields();
        self.location_id = null;
        self.showScheduleList = 0;
        // self.$refs.SMcalendar.$emit('refetch-events');
    },

    showEditMaintenance(event){
        var self = this;

        self.clearFields();
        self.location_id = null;
        self.isEditing = true;
        // $("#vehicle_select").addClass("disable-field");
        self.disableAssetField = true;
        self.schedule_maintenance_id = event.vehicleScheduleMaintenanceId;

        if(event.vehicleScheduledDate  != undefined && event.vehicleScheduledDate  != ''){
            self.vehicleScheduledDate = event.vehicleScheduledDate;
        }else{
            self.vehicleScheduledDate = '';
        }
        if(event.scheduleDateFrom  != undefined && event.scheduleDateFrom  != ''){
            self.schedule_date= event.scheduleDateFrom;
        }else{
             self.schedule_date = '';
        }
        /*if(event.scheduleDateTo  != undefined && event.scheduleDateTo  != ''){
            self.schedule_to_date= event.scheduleDateTo;
        }else{
             self.schedule_to_date = '';
        }*/
        if(event.scheduleTime24From  != undefined && event.scheduleTime24From  != ''){
            self.schedule_time={text:event.scheduleTimeFrom,value:event.scheduleTime24From};
        }else{
             self.schedule_time = null;
        }
        /*if(event.scheduleTime24To  != undefined && event.scheduleTime24To  != ''){
             self.schedule_to_time={text:event.scheduleTimeTo,value:event.scheduleTime24To};
        }else{
             self.schedule_to_time = null;
        }*/

        self.schedule_status = {value: event.vehicleSchedule, text: self.titleCase(event.vehicleSchedule) };
        //in case of add
        if(event.vehicleScheduleMaintenanceId == 0){
            self.maintenance_type = null;
            self.maintenance_type_name = "-";
            self.recalls = '';
            self.recallName = false;
        }else{
            self.maintenance_type = {value: event.vehicleMaintenanceType, text: self.titleCase(event.vehicleMaintenanceTypeName) };
            self.maintenance_type_name = event.vehicleMaintenanceTypeName;
            if (self.maintenance_type_name.toLowerCase() == "recall") {
                self.recallName = true;
                if (event.recallName != undefined && event.recallName != null && event.recallName != "") {
                    self.recalls = {text:event.recallName,value:event.recallName};
                }else{
                    self.recalls = '';
                }
                self.getRecalls();
            }else{
                self.recalls = '';
                self.recallName = false;
            }
        }
        if(event.vehicleNotes  != undefined && event.vehicleNotes  != ''){
            self.notes = event.vehicleNotes;
        }else{
            self.notes = '';
        }
        /*self.default_schedule_date = event.vehicleDefaultScheduledDate;
        self.last_service_date = event.vehicleDateInService;
        self.schedule_status = {value: event.vehicleSchedule, text: self.titleCase(event.vehicleSchedule) };
        self.maintenance_type = {value: event.vehicleMaintenanceType, text: self.titleCase(event.vehicleMaintenanceType) };


        if(event.vehicleNotes  != undefined && event.vehicleNotes  != ''){
            self.notes = event.vehicleNotes;
        }else{
            self.notes = '';
        }

        if(event.vehicleScheduledDate  != undefined && event.vehicleScheduledDate  != ''){
            self.schedule_date = event.vehicleScheduledDate;
        }else{
            self.schedule_date = '';
        }*/

        if(event.vehicleId == null) {
            self.vehicle_id = null;
        }else{
            // self.vehicle_id = {value: event.vehicleId, text: self.titleCase(event.vehicleName) + " (" + self.titleCase(event.vehicleUnitNo) +")" + " (" + self.titleCase(event.vehicleTypeCode) +")"};
            var vehicleData = self.titleCase(event.vehicleUnitNo);
            if(event.vehicleTypeCode != null && event.vehicleTypeCode != ''){
                vehicleData += " | " + self.titleCase(event.vehicleTypeCode);
                self.vehicle_type_code = self.titleCase(event.vehicleTypeCode);
            }
            if(event.vehicleName != null && event.vehicleName != ''){
                vehicleData += " | " + self.titleCase(event.vehicleName);
                self.vehicle_name = self.titleCase(event.vehicleName);
            }
            self.vehicle_id = {value: event.vehicleId, text: vehicleData};
            self.vehicle_unit_no = self.titleCase(event.vehicleUnitNo);
            self.fetchAssetEstimate();
        }

        if(event.vehicleLocationId == null) {
            self.location_id = null;
        }else{
            self.location_id = {value: event.vehicleLocationId, text: self.titleCase(event.vehicleLocationName) + " (" + self.titleCase(event.vehicleLocationCode) +")"};
        }

        /*
        if(event.vehicleCustId == null) {
            self.customer_id = null;
        }else{
            self.customer_id = event.vehicleCustId;
            self.customer_name = self.titleCase(event.vehicleCustName);
        }*/

        // self.showScheduleList = 1;
        self.scheduleTab();

    },

    onSearchAsset(search, loading) {
        var self = this;
        // use this in order to create new asset...
        self.searchedAsset = search;
        if (search.length > 3) {
            loading(true);
            self.searchField(loading, search, 'vehicle');
        }else{
            self.isAssetNotFound = false;
        }
    },

    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },
    onSearchEstimate(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'estimate', '');
        }
    },

    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },

    getScheduledAssetList() {

        var self = this;
        self.loading = true;
        self.startDateFrom = self.$refs.SMcalendar.fireMethod('getView').start.format();
        self.endDateTo = self.$refs.SMcalendar.fireMethod('getView').end.format();

        console.log('startDateFrom : '+self.startDateFrom);
        console.log('endDateTo : '+self.endDateTo);

        var timedifference = new Date().getTimezoneOffset();

        var startdate = (self.startDateFrom === null || typeof self.startDateFrom === "undefined") ? 0 : self.startDateFrom;
        var endDateTo = (self.endDateTo === null || typeof self.endDateTo === "undefined") ? 0 : self.endDateTo;
        
        //only dates for leave calendar data
        var startCalDate = (self.startDateFrom === null || typeof self.startDateFrom === "undefined") ? "" : self.startDateFrom;
        var endCalDate = (self.endDateTo === null || typeof self.endDateTo === "undefined") ? "" : self.endDateTo;

        if (startdate != 0 || endDateTo != 0) {
            startdate = moment(startdate, "YYYY-MM-DD HH:mm:ss").add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss");
            endDateTo = moment(endDateTo, "YYYY-MM-DD HH:mm:ss").add(+1, 'days').add(timedifference, 'minutes').format("YYYY-MM-DD HH:mm:ss");
        }
        console.log('startdate : '+startdate);
        console.log('endDateTo : '+endDateTo);

        var assetMaintenanceType = (self.asset_maintenance_type != '')?self.asset_maintenance_type.value:'';

        var assetCustomerId = (self.asset_customer_id != null)?self.asset_customer_id.value:null;
        var locationId =0;
        if(self.asset_location_id!=null ){
           locationId =self.asset_location_id.value;
        }

        $.ajax({
            url: process.env.ROOT_API + "/schedule_maintenance/get_maintenance_schedule_list",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType: "json",
            data:{
                start_date: startdate,
                end_date: endDateTo,
                location_id: locationId,
                customer_id: assetCustomerId,
                maintenance_type: assetMaintenanceType,
                start_cal_date:startCalDate,
                end_cal_date:endCalDate
            },
            success: function (data) {
                self.loading = false;
                self.events = [];
                if (data.status == "success") {
                    self.keysArr = [];
                    self.events = self.display_events = data.content.row;
                    $.each(data.content.keys, function (i) {
                        data.content.keys[i].is_view = 1;
                        self.keysArr.push(data.content.keys[i]);
                    });
                    self.$refs.SMcalendar.$emit('refetch-events');

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, false, 'maintenance-schedule-list');
            }
        });
    },
    onMaintenanceTypeChange() {
        var self = this;
        if (self.maintenance_type != null) {
            if(self.maintenance_type.text == 'Recall'){

                self.recallName = true;
                self.getRecalls();
                return;
            }else{
                self.recallName = false;
            }
        }
    },

    loadScheduleFromPM:function(obj){
        var self = this;

        obj = obj[0];

        console.log(obj);
        if(obj.vehicle_id == null) {
            self.vehicle_id = null;
        }else{
            // self.vehicle_id = {value: obj.vehicleId, text: self.titleCase(obj.vehicleName) + " (" + self.titleCase(obj.vehicleUnitNo) +")" + " (" + self.titleCase(obj.vehicleTypeCode) +")"};
            var vehicleData = self.titleCase(obj.unit_no);
            if(obj.truck_type != null && obj.truck_type != ''){
                vehicleData += " | " + self.titleCase(obj.truck_type);
                self.vehicle_type_code = self.titleCase(obj.truck_type);
            }
            if(obj.vehicle_name != null && obj.vehicle_name != ''){
                vehicleData += " | " + self.titleCase(obj.vehicle_name);
                self.vehicle_name = self.titleCase(obj.vehicle_name);
            }
            self.vehicle_id = {value: obj.vehicle_id, text: vehicleData};
            self.vehicle_unit_no = self.titleCase(obj.unit_no);
        }
        if(obj.due_date  != undefined && obj.due_date  != ''){
            self.vehicleScheduledDate = obj.due_date;
        }else{
            self.vehicleScheduledDate = '';
        }
        setTimeout(function(){
            if(obj.due_date  != undefined && obj.due_date  != ''){
                // self.schedule_date= obj.due_date;
                self.schedule_date = moment(new Date()).format("MM/DD/YYYY");
            }else{
                self.schedule_date = '';
            }

            if(obj.cust_id == null) {
                self.customer_id = null;
            }else{
                self.customer_id = obj.cust_id;

                self.asset_customer_id = {value: obj.cust_id, text: obj.cust_code+' | '+obj.cust_name};
                self.customer_name = obj.cust_name;
            }
        },500);
        
        /*if(obj.due_date  != undefined && obj.due_date  != ''){
            self.schedule_to_date= obj.due_date;
        }else{
            self.schedule_to_date = '';
        }*/
        self.schedule_time=self.timeArr[4];
        // self.schedule_to_time=self.timeArr[42];

        self.schedule_status = self.scheduleStatusArr[0];
       
        if(obj.vehicleNotes  != undefined && obj.vehicleNotes  != ''){
            self.notes = obj.vehicleNotes;
        }else{
            self.notes = '';
        }
       
        if(obj.location_id == null) {
            self.location_id = null;
        }else{
            self.location_id = {value: obj.location_id, text: obj.location};
        }

        if (obj.completion_date != null && obj.completion_date != ''){
            self.last_service_date = obj.completion_date;
        }
        // setTimeout(function(){
        //     self.maintenance_type = self.maintenanceTypeArr[0];
        // },2500);
    },
    fetchAssetEstimate() {
        var self = this;
        if (self.vehicle_id != null && self.vehicle_id != "" && self.vehicle_id.value) {
            self.searchField("loading","","asset_estimates",self.vehicle_id.value);
        }
    },
    onAssetSelect() {
        var self = this;
        self.fetchAssetEstimate();
    },
    onEstimateSelect(){
        var self = this;
        if (self.estimate_id != null) {
            if (self.estimate_id.open_date != null && self.estimate_id.open_date != "") {
                self.schedule_date = self.estimate_id.open_date;
            }
            if (self.estimate_id.open_date_time != null && self.estimate_id.open_date_time != "") {
                if (self.estimate_id.open_date_time_text != null && self.estimate_id.open_date_time_text != "") {
                    self.schedule_time = {text:self.estimate_id.open_date_time_text,value:self.estimate_id.open_date_time};
                }
            }
            //maintenance type from customer estimate
            if (self.estimate_id.maintenance_type_id != null && self.estimate_id.maintenance_type_id != "") {
                self.maintenance_type = {text:self.estimate_id.maintenance_type_name,value:self.estimate_id.maintenance_type_id};
            }
        }
    }
    
  }
};

//show calendar page on click sidebar menu
EventBus.$on('showCalendarPage', function (isLogin) {

    if ( contex.showScheduleList == 1 ) {
        contex.showScheduleList = 0;
    }

});
</script>



// WEBPACK FOOTER //
// src/components/MaintenanceSchedule.vue